import { snakeCase } from 'lodash/fp';
import { atomWithMutation } from 'jotai-tanstack-query';
import { UserNavOverrides } from '@statsbomb/parachute-types';
import { KeysToCamelCase } from '@/types/generic';
import { rawUserNavOverridesAtom } from '@/atoms/queries/user';
import { fetchClientAtom } from '../../queries/client';

export const patchUserNavOverridesAtom = atomWithMutation(get => {
  const mutationKey = ['patchUserNavOverrides'];
  const mutationFn = async (userNavOverrideMutation: KeysToCamelCase<UserNavOverrides>) => {
    const { fetch } = get(fetchClientAtom);
    const userNavOverrides = await get(rawUserNavOverridesAtom);

    const formattedUserNavOverrideMutation = Object.entries(userNavOverrideMutation).reduce(
      (acc, [key, value]) => ({
        ...acc,
        [snakeCase(key)]: value,
      }),
      {},
    );

    try {
      await fetch(`/user/nav-overrides`, {
        method: 'PUT',
        headers: {
          'Content-type': 'application/json',
        },
        body: JSON.stringify(formattedUserNavOverrideMutation),
      });
    } catch {
      return { isSuccess: false };
    }

    await userNavOverrides.refetch();
    return { isSuccess: true };
  };

  return { mutationFn, mutationKey };
});
